<template>
  <SelectSingleInput
    :vid="vid"
    v-model="model"
    :items="items"
    item-text="userText"
    item-value="userCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'UserInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0154')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  methods: {
    async setUser() {
      this.loading = true
      try {
        let params = {
          validOnly: this.validOnly,
        }
        if (!this.disabled) {
          params.companyCat = this.$store.getters.companyCatCd
          if (this.$store.getters.isSupplier) {
            params.companyCd = this.$store.getters.companyCd
          }
        }

        const elements = await API.get('/master/company/users', params)
        this.items = []
        elements.forEach((element) => {
          element['userText'] = element['userCd'] + ' : ' + element['userName']
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0058') })))
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.setUser()
  },
}
</script>
